import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  Card, Grid, Loader, Icon,
} from 'semantic-ui-react';
import 'react-datepicker/dist/react-datepicker.css';
import {Actions} from '../../../../common/actions';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {paths} from '../../../../common/dictionaries/urls';
import {getNumericValue} from '../../../../common/util/fieldsValidation';
import DataByMonths from './table';
import ComposedChart from './chart';
import SalesTable from './table/sales';
import OnOrdersTable from './table/onOrders';
import ReceptionsOrdersTable from './table/receptionsOrders';
import './partWatching.scss';

class PartWatching extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showSalesTable': false,
      'showOnOrdersTable': false,
      'showReceptionsOrdersTable': false,
      'referenceLineForSales': '',
      'referenceLineForReceptions': '',
    };
    this.onCancelClick = this.onCancelClick.bind(this);
    this.onOrdersBarClick = this.onOrdersBarClick.bind(this);
    this.salesLineClick = this.salesLineClick.bind(this);
    this.receptionsBarClick = this.receptionsBarClick.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.PartWatching, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }
    const {code} = this.props;
    this.props.clearPartWatching();
    this.props.fetchPartWatching(code);
  }

  componentDidUpdate(prevProps) {
    const {code} = this.props;
    if (code !== prevProps.code) {
      this.props.fetchPartWatching(code);
    }
  }

  onOrdersBarClick(year, month) {
    this.showSalesAndOnOrder(year, month);
  }

  salesLineClick(year, month) {
    this.showSalesAndOnOrder(year, month);
  }

  onCancelClick() {
    this.props.goBack();
  }

  showSalesAndOnOrder(year, month) {
    const {code} = this.props;
    this.props.fetchSalesByYearAndMonth(code, year, month);
    this.props.fetchOnOrdersByYearAndMonth(code, year, month);
    this.setState({
      'showSalesTable': true,
      'showOnOrdersTable': true,
      'referenceLineForSales': `${month}-${year}`,
    });
  }

  receptionsBarClick(year, month) {
    const {code} = this.props;
    this.props.fetchReceptionsOrdersByYearAndMonth(code, year, month);
    this.setState({
      'showReceptionsOrdersTable': true,
      'referenceLineForReceptions': `${month}-${year}`,
    });
  }

  renderItem(title, value) {
    return (
      <Grid.Column>
        <div className='title-bar'>
          <div className='title'>
            <h4>{title}</h4>
            <div className='title-bar-actions'>
              {value}
            </div>
          </div>
        </div>
      </Grid.Column>
    );
  }

  renderDataSection() {
    const {loading, data} = this.props;
    if (loading) {
      return <Loader active inline='centered' />;
    }

    return (
      <Grid columns='equal' className='data-section'>
        <Grid.Row>
          {this.renderItem('ICC:', data.icc)}
          {this.renderItem('MAD:', getNumericValue(data.mad, 2))}
          {this.renderItem('MIP:', getNumericValue(data.mip, 2))}
          {this.renderItem('L/T:', getNumericValue(data.leadTime, 2))}
          {this.renderItem('S/ST:', getNumericValue(data.safetyStockLeadTime, 2))}
        </Grid.Row>
        <Grid.Row>
          {this.renderItem('SCC:', data.scc)}
          {this.renderItem('OC:', getNumericValue(data.orderCycle, 2))}
          {this.renderItem('SOQ:', getNumericValue(data.soq, 2))}
          {this.renderItem('S/SD:', getNumericValue(data.safetyStockMad, 2))}
          {this.renderItem('', '')}
        </Grid.Row>
      </Grid>
    );
  }

  renderSalesTable() {
    const {showSalesTable} = this.state;
    if (!showSalesTable) {
      return null;
    }
    return <SalesTable />;
  }

  renderOnOrdersTable() {
    const {showOnOrdersTable} = this.state;
    if (!showOnOrdersTable) {
      return null;
    }
    return <OnOrdersTable />;
  }

  renderReceptionsOrdersTable() {
    const {showReceptionsOrdersTable} = this.state;
    if (!showReceptionsOrdersTable) {
      return null;
    }
    return <ReceptionsOrdersTable />;
  }

  render() {
    const {code, data} = this.props;
    const {referenceLineForSales, referenceLineForReceptions} = this.state;

    return (
      <div className='part-watching'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <Icon name='arrow left' onClick={this.onCancelClick}/>
              <h2>{code}</h2>
            </div>
            <div className='subtitle'>
              {data.franchise} | {data.partName}
            </div>
          </div>
        </Card>

        <Card raised fluid>
          {this.renderDataSection()}
        </Card>

        <DataByMonths />

        <ComposedChart type='sales' activeOnOrdersBarClick={this.onOrdersBarClick}
          activeSaleLineClick={this.salesLineClick}
          referenceLine={referenceLineForSales} />

        {this.renderSalesTable()}
        {this.renderOnOrdersTable()}

        <ComposedChart type='receptions' activeReceptionsBarClick={this.receptionsBarClick}
          referenceLine={referenceLineForReceptions} />

        {this.renderReceptionsOrdersTable()}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {code} = ownProps.params;
  return {
    code,
    'loading': state.partWatching.loading,
    'data': state.partWatching.partWatching,
    'menuSelected': state.menu.selected,
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'goBack': ownProps.history.goBack,
  };
};

const {
  clearPartWatching,
  fetchPartWatching,
  fetchSalesByYearAndMonth,
  fetchOnOrdersByYearAndMonth,
  fetchReceptionsOrdersByYearAndMonth,
  withRouter,
} = Actions;

export default withRouter(connect(mapStateToProps, {
  clearPartWatching,
  fetchPartWatching,
  fetchSalesByYearAndMonth,
  fetchOnOrdersByYearAndMonth,
  fetchReceptionsOrdersByYearAndMonth,
})(PartWatching));
